export const wordInvoiceData = {
  companyName: "TechNova Solutions Pvt. Ltd.",
  companyAddress: "45, Industrial Area, Pune, Maharashtra, 411045, India",
  companyGSTIN: "27AAEFT1234Q1Z9",
  invoiceNumber: "INV/2026/045",
  date: "15 Jan 2026",
  clientName: "Mr. Rohan Sharma",
  clientAddress: "12, MG Road, Mumbai, Maharashtra, 400001, India",
  items: [
    { id: 1, desc: "Laptop Repair", qty: 2, rate: 12500 },
    { id: 2, desc: "Software Installation", qty: 3, rate: 2000 },
    { id: 3, desc: "Networking Setup", qty: 1, rate: 8000 },
  ],
  taxRate: 18, 
};

wordInvoiceData.items = wordInvoiceData.items.map(item => ({
  ...item,
  amount: item.qty * item.rate
}));

wordInvoiceData.subtotal = wordInvoiceData.items.reduce((a, i) => a + i.amount, 0);
wordInvoiceData.taxAmount = +(wordInvoiceData.subtotal * wordInvoiceData.taxRate / 100).toFixed(2);
wordInvoiceData.total = wordInvoiceData.subtotal + wordInvoiceData.taxAmount;
wordInvoiceData.balanceDue = wordInvoiceData.total;
